import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import BifrostContent from '../components/Bifrost/BifrostContent/BifrostContent'
import BifrostHero from '../components/Bifrost/BifrostHero/BifrostHero'

const Bifrost = ({ data }) => {
  const postNode = {
    title: `Bifrost - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="bifrost" customTitle />
      <Helmet>
        <title>{`Bifrost - ${config.siteTitle}`}</title>
      </Helmet>
      <BifrostHero />
      <BifrostContent />
    </Layout>
  )
}

export default Bifrost
